import {
    Button,
    Checkbox,
    ClickAwayListener,
    Dialog,
    DialogActions,
    DialogTitle,
    List,
    ListItem,
    Paper,
    Popper,
    Tooltip,
    Typography
} from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import IconeJulgarPlanilha from '../../img/IconeJulgarPlanilha';
import ReactComponent from '../ReactComponent';

class JulgarPlanilha extends ReactComponent {
    dialogOpen = false;
    removerDestaques = false;
    removerVistaMesa = false;
    removerVistaRegimental = false;
    removerAnotacoes = false;
    removerSequencial = false;
    abrirPopover = false;
    opcaoSelecionada;

    handleClickIconeJulgar = (event) => {
        if (!this.acabouDeFechar) {
            this.abrirPopover = true;
            this.anchorEl = event.currentTarget;
        }
    };

    handleClosePopper = () => {
        this.acabouDeFechar = true;
        setTimeout(() => {
            runInAction(() => {
                this.acabouDeFechar = false;
            });
        }, 10);
        this.abrirPopover = false;
        this.anchorEl = null;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogOpen: observable,
            removerDestaques: observable,
            removerVistaMesa: observable,
            removerVistaRegimental: observable,
            removerAnotacoes: observable,
            removerSequencial: observable,
            abrirPopover: observable,
            opcaoSelecionada: observable,
            handleClickIconeJulgar: action,
            handleClosePopper: action,
            opcoesRelatores: computed,
            handleClickRelator: action,
            processosPendentesRelatorSelecionado: computed,
            handleClickBotaoJulgar: action,
            mensagemRemovidos: computed,
            filtrar: action,
            handleCloseDialog: action,
            handleChange: action,
            handleChangeDestaques: action,
            handleChangeVistaMesa: action,
            handleChangeVistaRegimental: action,
            handleChangeAnotacoes: action,
            handleChangeSequencial: action,
            quantidadeVistaMesa: computed,
            quantidadeVistaRegimental: computed,
            quantidadeDestaques: computed,
            quantidadeAnotacoes: computed,
            quantidadeSequencial: computed,
            quantidadeReduzida: computed
        });
    }

    get opcoesRelatores() {
        return this.salaSessaoStore.opcoesRelatoresApregoamento;
    }

    handleClickRelator = (opcaoRelator) => {
        this.opcaoSelecionada = opcaoRelator;
        this.handleClosePopper();
        this.dialogOpen = true;
    };

    get processosPendentesRelatorSelecionado() {
        if (this.opcaoSelecionada) {
            let processosRelator = this.salaSessaoStore.processosPendentesRelator(this.opcaoSelecionada.value);
            return processosRelator.filter((registro) => !registro.necessitaImportacaoSalaSessao);
        }
        return [];
    }

    handleClickBotaoJulgar = async () => {
        let processos = this.processosPendentesRelatorSelecionado;
        processos = !this.removerDestaques ? this.filtrar('filtroDestaques', processos, false) : processos;
        processos = !this.removerVistaMesa ? this.filtrar('filtroVistaMesa', processos, false) : processos;
        processos = !this.removerVistaRegimental
            ? this.filtrar('filtroRetornoVistaRegimental', processos, false)
            : processos;
        processos = !this.removerAnotacoes ? this.filtrar('filtroAnotacoes', processos, false) : processos;
        processos = !this.removerSequencial ? this.filtrar('filtroSequencial', processos, false) : processos;
        if (processos.length === 0) {
            this.mensagemStore.abrirMensagemInfo('Não há processos a serem julgados.' + this.mensagemRemovidos);
        } else {
            await this.salaSessaoStore.julgarProcessos(processos, this.salaSessaoStore.tipoResultadoJulgamentoJulgado);
            this.handleCloseDialog();
            this.salaSessaoStore.recarregarListaProcessos();
        }
    };

    get mensagemRemovidos() {
        let retorno = !this.removerVistaMesa ? 'Vista em mesa, ' : '';
        retorno = !this.removerVistaRegimental ? retorno + 'Vista regimental, ' : retorno;
        retorno = !this.removerDestaques ? retorno + 'Manifestações (Destaques), ' : retorno;
        retorno = !this.removerAnotacoes ? retorno + 'Anotações, ' : retorno;
        retorno = !this.removerSequencial ? retorno + 'Sequencial, ' : retorno;
        retorno =
            retorno.length > 0
                ? ' Não foram incluídos na planilha, processos que possuem: ' + retorno.slice(0, retorno.length - 2)
                : retorno;
        return retorno;
    }

    filtrar(idFiltro, processos, valor) {
        return this.salaSessaoStore.filtros[idFiltro].filtrar(processos, valor);
    }

    handleCloseDialog = () => {
        this.resetOpcoes();
        this.opcaoSelecionada = undefined;
        this.dialogOpen = false;
    };

    handleChange = (atributo) => {
        this[atributo] = !this[atributo];
    };

    handleChangeDestaques = () => {
        this.removerDestaques = !this.removerDestaques;
    };

    handleChangeVistaMesa = () => {
        this.removerVistaMesa = !this.removerVistaMesa;
    };

    handleChangeVistaRegimental = () => {
        this.removerVistaRegimental = !this.removerVistaRegimental;
    };

    handleChangeAnotacoes = () => {
        this.removerAnotacoes = !this.removerAnotacoes;
    };

    handleChangeSequencial = () => {
        this.removerSequencial = !this.removerSequencial;
    };

    resetOpcoes() {
        this.removerSequencial = false;
        this.removerAnotacoes = false;
    }

    get quantidadeVistaMesa() {
        return this.filtrar('filtroVistaMesa', this.processosPendentesRelatorSelecionado, true).length;
    }

    get quantidadeVistaRegimental() {
        return this.filtrar('filtroRetornoVistaRegimental', this.processosPendentesRelatorSelecionado, true).length;
    }

    get quantidadeDestaques() {
        let listaSemVistas = this.filtrar(
            'filtroRetornoVistaRegimental',
            this.filtrar('filtroVistaMesa', this.processosPendentesRelatorSelecionado, false),
            false
        );
        return this.filtrar('filtroDestaques', listaSemVistas, true).length;
    }

    get quantidadeAnotacoes() {
        let listaSemVistas = this.filtrar(
            'filtroRetornoVistaRegimental',
            this.filtrar('filtroVistaMesa', this.processosPendentesRelatorSelecionado, false),
            false
        );
        return this.filtrar('filtroAnotacoes', listaSemVistas, true).length;
    }

    get quantidadeSequencial() {
        let listaSemVistas = this.filtrar(
            'filtroRetornoVistaRegimental',
            this.filtrar('filtroVistaMesa', this.processosPendentesRelatorSelecionado, false),
            false
        );
        return this.filtrar('filtroSequencial', listaSemVistas, true).length;
    }

    get quantidadeReduzida() {
        let listaReduzida = this.filtrar('filtroDestaques', this.processosPendentesRelatorSelecionado, false);
        listaReduzida = this.filtrar('filtroAnotacoes', listaReduzida, false);
        listaReduzida = this.filtrar('filtroRetornoVistaRegimental', listaReduzida, false);
        listaReduzida = this.filtrar('filtroVistaMesa', listaReduzida, false);
        listaReduzida = this.filtrar('filtroSequencial', listaReduzida, false);

        return listaReduzida.length;
    }

    elementoIconeJulgarLote = () => {
        return document.getElementById('iconeJulgarLote');
    };

    render() {
        return (
            <div>
                <div
                    id="iconeJulgarLote"
                    style={{ marginRight: '10px' }}
                    className="corBotao"
                >
                    <Tooltip
                        title={'Julgar planilha'}
                        placement="top-start"
                    >
                        <span>
                            <IconeJulgarPlanilha
                                onClick={this.handleClickIconeJulgar}
                                style={{ cursor: 'pointer' }}
                            />
                        </span>
                    </Tooltip>
                </div>
                {this.abrirPopover && (
                    <Popper
                        onClick={(event) => event.preventDefault()}
                        open={this.abrirPopover}
                        anchorEl={this.elementoIconeJulgarLote}
                        placement="bottom-start"
                        style={{ zIndex: '99' }}
                    >
                        <ClickAwayListener onClickAway={this.handleClosePopper}>
                            <Paper>
                                <Typography
                                    variant="subtitle1"
                                    style={{ padding: '5px 15px 5px 15px', fontWeight: 'bold' }}
                                >
                                    Julgar planilha
                                </Typography>
                                {this.opcoesRelatores.length > 0 ? (
                                    <List>
                                        {this.opcoesRelatores.map((opcaoRelator) => (
                                            <ListItem
                                                button
                                                key={this.nextKey}
                                                onClick={() => this.handleClickRelator(opcaoRelator)}
                                                style={{
                                                    color:
                                                        opcaoRelator.value === this.sessaoStore.relatorPregaoLote
                                                            ? red[900]
                                                            : 'black',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <Typography
                                                    display="inline"
                                                    fontWeight="bold"
                                                >
                                                    {opcaoRelator.label}
                                                </Typography>
                                                <Typography style={{ marginLeft: '5px', fontSize: '11pt' }}>
                                                    {'(Pendentes: ' +
                                                        opcaoRelator.qtdPendentes +
                                                        (opcaoRelator.qtdPendentes > 1
                                                            ? ' / Primeiro: ' +
                                                              opcaoRelator.primeiroProcesso +
                                                              ' / Último: ' +
                                                              opcaoRelator.ultimoProcesso
                                                            : ' / Processo: ' + opcaoRelator.primeiroProcesso) +
                                                        ')'}
                                                </Typography>
                                            </ListItem>
                                        ))}
                                    </List>
                                ) : (
                                    <Typography style={{ padding: '5px 15px 5px 15px' }}>
                                        Não há processos pendentes
                                    </Typography>
                                )}
                            </Paper>
                        </ClickAwayListener>
                    </Popper>
                )}
                {this.opcaoSelecionada && this.dialogOpen && (
                    <Dialog
                        onClose={this.handleCloseDialog}
                        open={this.dialogOpen}
                    >
                        <DialogTitle
                            id="simple-dialog-title"
                            style={{ paddingBottom: '0px' }}
                        >
                            {`Julgar planilha de processos do relator ${this.opcaoSelecionada.label}`}
                        </DialogTitle>
                        <List>
                            <ListItem
                                key={this.nextKey}
                                dense={true}
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        style={{ padding: '5px' }}
                                        color="primary"
                                        checked={true}
                                        disabled={true}
                                    />
                                    <Typography
                                        variant="subtitle1"
                                        color="inherit"
                                    >
                                        Ser{this.quantidadeReduzida === 1 ? 'á' : 'ão'} julgado
                                        {this.quantidadeReduzida === 1 ? '' : 's'}{' '}
                                        <b>{this.quantidadeReduzida ? this.quantidadeReduzida : 0}</b> processo
                                        {this.quantidadeReduzida === 1 ? '' : 's'}.
                                    </Typography>
                                </div>
                            </ListItem>
                            {this.quantidadeVistaMesa + this.quantidadeVistaRegimental > 0 && (
                                <Fragment>
                                    <ListItem>
                                        <div style={{ fontWeight: 'bold' }}>Não incluídos:</div>
                                    </ListItem>
                                    {this.quantidadeVistaMesa > 0 && (
                                        <ListItem
                                            key={this.nextKey}
                                            dense={true}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography
                                                    variant="subtitle1"
                                                    color="inherit"
                                                >
                                                    {'Vista em mesa (' + this.quantidadeVistaMesa + ')'}
                                                </Typography>
                                            </div>
                                        </ListItem>
                                    )}
                                    {this.quantidadeVistaRegimental > 0 && (
                                        <ListItem
                                            key={this.nextKey}
                                            dense={true}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography
                                                    variant="subtitle1"
                                                    color="inherit"
                                                >
                                                    {'Retorno de vista regimental (' +
                                                        this.quantidadeVistaRegimental +
                                                        ')'}
                                                </Typography>
                                            </div>
                                        </ListItem>
                                    )}
                                </Fragment>
                            )}
                            {this.quantidadeDestaques + this.quantidadeAnotacoes + this.quantidadeSequencial > 0 && (
                                <DialogTitle
                                    id="simple-dialog-title"
                                    style={{ paddingBottom: '0px' }}
                                >
                                    <div style={{ fontSize: 'medium' }}>
                                        <Typography display="inline">
                                            Para{' '}
                                            <Typography
                                                display="inline"
                                                fontWeight="bold"
                                            >
                                                INCLUIR
                                            </Typography>{' '}
                                            na planilha{' '}
                                        </Typography>
                                        <Typography
                                            display="inline"
                                            fontStyle="italic"
                                            fontWeight="bold"
                                        >
                                            selecione
                                        </Typography>{' '}
                                        <Typography display="inline">os processos com:</Typography>
                                    </div>
                                </DialogTitle>
                            )}
                            {this.quantidadeDestaques > 0 && (
                                <ListItem
                                    key={this.nextKey}
                                    dense={true}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox
                                            style={{ padding: '5px' }}
                                            color="primary"
                                            onChange={() => this.handleChange('removerDestaques')}
                                            checked={this.removerDestaques}
                                        />
                                        <Typography
                                            variant="subtitle1"
                                            color="inherit"
                                        >
                                            {'Manifestações (Destaques) (' + this.quantidadeDestaques + ')'}
                                        </Typography>
                                    </div>
                                </ListItem>
                            )}
                            {this.quantidadeAnotacoes > 0 && (
                                <ListItem
                                    key={this.nextKey}
                                    dense={true}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox
                                            style={{ padding: '5px' }}
                                            color="primary"
                                            onChange={() => this.handleChange('removerAnotacoes')}
                                            checked={this.removerAnotacoes}
                                        />
                                        <Typography
                                            variant="subtitle1"
                                            color="inherit"
                                        >
                                            {'Anotações do Secretário (' + this.quantidadeAnotacoes + ')'}
                                        </Typography>
                                    </div>
                                </ListItem>
                            )}
                            {this.quantidadeSequencial > 0 && (
                                <ListItem
                                    key={this.nextKey}
                                    dense={true}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox
                                            style={{ padding: '5px' }}
                                            color="primary"
                                            onChange={() => this.handleChange('removerSequencial')}
                                            checked={this.removerSequencial}
                                        />
                                        <Typography
                                            variant="subtitle1"
                                            color="inherit"
                                        >
                                            {'Número sequencial (' + this.quantidadeSequencial + ')'}
                                        </Typography>
                                    </div>
                                </ListItem>
                            )}
                        </List>
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={this.handleClickBotaoJulgar}
                                color="primary"
                            >
                                Julgar
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </div>
        );
    }
}

export default inject('stores')(observer(JulgarPlanilha));
